import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { TabProvider, useTab } from './contexts/TabContext'
import { Login } from './components/Login'
import { QuestionList } from './components/QuestionList'
import { DrawingList } from './components/DrawingList'
import { UserManagement } from './components/UserManagement'
import { BookList } from './components/BookList'
import { QuestionGroupList } from './components/QuestionGroupList'
import { HierarchicalQuestionNav } from './components/HierarchicalQuestionNav'
import { Settings } from './components/Settings'
import { PasswordResetRequest } from './components/PasswordResetRequest'
import { UpdatePassword } from './components/UpdatePassword'
import { AcceptInvitation } from './components/AcceptInvitation'
import { TagManagement } from './components/TagManagement'

function AppContent() {
  const { user, loading, needsPasswordSetup } = useAuth()
  const { activeTab } = useTab()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">로딩 중...</div>
      </div>
    )
  }

  // 비밀번호 설정이 필요한 경우 (초대 또는 비밀번호 재설정)
  if (user && needsPasswordSetup) {
    return (
      <Routes>
        <Route path="/accept-invitation" element={<AcceptInvitation />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="*" element={<Navigate to="/accept-invitation" replace />} />
      </Routes>
    )
  }

  if (!user) {
    // Unauthenticated routes
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<PasswordResetRequest />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/accept-invitation" element={<AcceptInvitation />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  // Authenticated routes
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/questions" replace />} />
      <Route path="/questions" element={<QuestionList />} />
      <Route path="/solutions" element={<DrawingList />} />
      <Route path="/users" element={<UserManagement />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/update-password" element={<UpdatePassword />} />
      <Route path="/books" element={<BookList />} />
      <Route path="/books/:bookId/groups" element={<QuestionGroupList />} />
      <Route path="/hierarchy" element={<HierarchicalQuestionNav />} />
      <Route path="/tags" element={<TagManagement />} />
      <Route path="*" element={<Navigate to="/questions" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <TabProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </TabProvider>
    </AuthProvider>
  )
}

export default App
